// Per-device preferences, kept in this browser only. Storage can be blocked
// (private mode), so every read and write is allowed to fail.

export type SettingKey = 'helperMode' | 'listenMode'
const PREFIX = 'samjho-setting-'

export function readSetting(key: SettingKey): boolean {
  try {
    return localStorage.getItem(PREFIX + key) === '1'
  } catch {
    return false
  }
}

export function writeSetting(key: SettingKey, on: boolean): void {
  try {
    if (on) localStorage.setItem(PREFIX + key, '1')
    else localStorage.removeItem(PREFIX + key)
  } catch {
    /* not saved; the setting still applies until the page is closed */
  }
}

/** Light / dark: follow the phone unless the person picked one. */
export type ThemePref = 'system' | 'light' | 'dark'
const THEME_KEY = 'samjho-theme'

export function readTheme(): ThemePref {
  try {
    const v = localStorage.getItem(THEME_KEY)
    return v === 'light' || v === 'dark' ? v : 'system'
  } catch {
    return 'system'
  }
}

export function applyTheme(pref: ThemePref): void {
  const root = document.documentElement
  if (pref === 'system') delete root.dataset.theme
  else root.dataset.theme = pref
  const dark = pref === 'dark' || (pref === 'system' && window.matchMedia?.('(prefers-color-scheme: dark)').matches)
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#131715' : '#faf6ee')
  try {
    if (pref === 'system') localStorage.removeItem(THEME_KEY)
    else localStorage.setItem(THEME_KEY, pref)
  } catch {
    /* applies until the page is closed */
  }
}
